import axios from "axios";

export const WIDGET_STATES = "WIDGET_STATES";
export const ADD_SELECTED_VIDEO = "ADD_SELECTED_VIDEO";
export const REMOVE_SELECTED_VIDEO = "REMOVE_SELECTED_VIDEO";
export const CLEAR_SELECTED_VIDEOS = "CLEAR_SELECTED_VIDEOS";
export const UPDATE_VIDEO_SETTINGS = "UPDATE_VIDEO_SETTINGS";

export const updateWidgetState = (status) => ({
  type: WIDGET_STATES,
  status,
});

export const addSelectedVideo = (video) => ({
  type: ADD_SELECTED_VIDEO,
  payload: video,
});

export const updateVideoSettings = (videoId, newSettings) => ({
  type: UPDATE_VIDEO_SETTINGS,
  payload: { videoId, newSettings },
});

export const removeSelectedVideo = (id) => ({
  type: REMOVE_SELECTED_VIDEO,
  payload: id,
});

export const clearSelectedVideos = () => ({
  type: CLEAR_SELECTED_VIDEOS,
});

const apiUrl = process.env.REACT_APP_WIDGET_BASE_URL;
const apiKey =
  "ZhrsS5EtnaA1shtKyC6Tr3IOS5M1rQcRPjxyAk7jhndlNOlJbwUleGH0vEeEU4eb";

const getConfig = (method, data = null) => ({
  method,
  url: `${apiUrl}${method === "get" ? "" : "/widget"}`,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": apiKey,
  },
  data,
  maxBodyLength: Infinity,
});

export const createWidget = async (data) => {
  try {
    const response = await axios.post(
      `${apiUrl}/widget`,
      data,
      getConfig("post", data)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWidgetData = async (id) => {
  try {
    const response = await axios.get(
      `${apiUrl}/widget/${id}`,
      getConfig("get")
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShopifyProducts = async (
  shopifyAccessToken,
  shopifyStoreUrl
) => {
  try {
    const response = await axios.get(
      `${apiUrl}/products/inventory?shopifyAccessToken=${shopifyAccessToken}&shopifyStoreUrl=${shopifyStoreUrl}`,
      getConfig("get")
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateWidgetData = async (id, data) => {
  try {
    const response = await axios.put(
      `${apiUrl}/widget/${id}`,
      JSON.stringify(data),
      getConfig("put", data)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatePlaylistData = async (id, data) => {
  try {
    const response = await axios.put(
      `${apiUrl}/playlist/${id}`,
      JSON.stringify(data),
      getConfig("put", data)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteWidget = async (widgetId) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/widget/${widgetId}`,
      getConfig("delete")
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createPlaylist = async (data) => {
  try {
    const response = await axios.post(
      `${apiUrl}/playlist`,
      data,
      getConfig("post", data)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllWidgets = async (params) => {
  try {
    const response = await axios.get(`${apiUrl}/widgets/`, {
      ...getConfig("get"),
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generateWidgetToken = async (id) => {
  try {
    const response = await axios.post(
      `${apiUrl}/widget/${id}/token/generate`,
      null,
      getConfig("post")
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
